import { getIsProduction } from "./getEnvName";

export const getShouldUseZendeskSandbox = () => {
  return !getIsProduction();
};
